import axios from 'axios';

export const containerVentoleraApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/container-ventolera`,
    headers: {
        'Content-Type': 'application/json'
    }
})